import React from 'react';
import { translate } from 'react-i18next';
import CBMediaQuery from '../shared/CBMediaQuery';
import { getStyle } from '../../utils/utils';

class NoChainView extends React.Component {
  render() {
    const { t } = this.props;

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            <div style={getStyle(screenSize, styles, 'content')}>
              <img
                src='/img/ovio_carbook_logo.svg'
                alt='Ovio Carbook'
                style={getStyle(screenSize, styles, 'logo')}
              />
              <h2 style={getStyle(screenSize, styles, 'title')}>
                {t('noChainTitle')}
              </h2>
              <p style={getStyle(screenSize, styles, 'description')}>
                {t('noChainDescription')}
              </p>
            </div>
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 'calc(100vh - 100px)',
      padding: 20,
    },
    content: {
      textAlign: 'center',
      maxWidth: 500,
    },
    logo: {
      width: 200,
      marginBottom: 30,
    },
    title: {
      color: '#fff',
      fontSize: 24,
      marginBottom: 16,
    },
    description: {
      color: 'rgba(255, 255, 255, 0.8)',
      fontSize: 16,
      lineHeight: 1.5,
    },
  },
};

export default translate('ChainHomeView')(NoChainView);
